import React from 'react';
import { PaginationContainer, PageButton, PageInfo } from './Pagination.styled';

const Pagination = ({
    currentPage,
    totalPages,
    onPrevPage,
    onNextPage,
    hasPrevPage,
    hasNextPage
}) => {
    if (totalPages <= 1) return null;

    return (
        <PaginationContainer>
            <PageButton
                onClick={onPrevPage}
                disabled={!hasPrevPage}
                aria-label="Pagina anterior"
            >
                Anterior
            </PageButton>
            <PageInfo>
                Pagina {currentPage} de {totalPages}
            </PageInfo>
            <PageButton
                onClick={onNextPage}
                disabled={!hasNextPage}
                aria-label="Pagina siguiente"
            >
                Siguiente
            </PageButton>
        </PaginationContainer>
    );
};

export default Pagination;
